import React from 'react';
import css from './LastActivityCaption.css';
import { NamedLink } from '../../../components';
import { IconClockS, IconLockS } from '../../../icons';
import { datediff } from '../../../util/time';

const LastActivityCaption = ({ currentUser, publicUser, isSameUser }) => {
    const isLoggedIn = currentUser && currentUser.id;

    const calculateActivityState = () => {
        const { lastVisitedAt } = publicUser.attributes.profile.publicData;

        const { hours, days } = datediff(new Date(lastVisitedAt), new Date());
        const totalHours = hours + days * 24;

        if (totalHours <= 24) {
            return { text: 'Heute', className: 'justNow' };
        }
        if (totalHours > 24 && totalHours <= 48) {
            return { text: 'Gestern', className: 'justNow' };
        }
        if (totalHours > 48 && totalHours <= 168) {
            return { text: 'Diese Woche', className: 'justNow' };
        }
        if (totalHours > 168 && totalHours <= 336) {
            return { text: 'Letzte Woche', className: 'recently' };
        }
        if (totalHours > 336 && totalHours <= 672) {
            return { text: 'Diesen Monat', className: 'recently' };
        }
        if (totalHours > 672 && totalHours <= 1344) {
            return { text: 'Letzten Monat', className: 'recently' };
        }
        return { text: 'Mehr als 1 Monat', className: 'longTimeAgo' };
    };

    const renderCaptionContent = () => {
        if (!isLoggedIn) {
            return (
                <NamedLink name="SignupHorseowner" className={css.loggedOutLink}>
                    <IconLockS /> Letzte Aktivität ansehen
                </NamedLink>
            );
        }

        const { text, className } = calculateActivityState();

        return (
            <>
                <IconClockS /> Letzte Aktivität: <span className={css[className]}>{text}</span>
            </>
        );
    };

    return (
        <p className={css.root} datatype="activity-caption">
            {renderCaptionContent()}
        </p>
    );
};

export default LastActivityCaption;
